import { TextField } from '@mui/material';
import { FullRow } from './FormDialog';

export type ContactValue = {
  name: string;
  country: string;
  city: string;
  contact: string;
  phone: string;
  email: string;
};

/** The company and contact boxes every "add a company" form starts with (for FormDialog) */
export function ContactFields({
  value,
  onChange,
}: {
  value: ContactValue;
  onChange: (patch: Partial<ContactValue>) => void;
}) {
  return (
    <>
      <FullRow>
        <TextField
          label="Company name"
          required
          value={value.name}
          onChange={(e) => onChange({ name: e.target.value })}
        />
      </FullRow>
      <TextField label="Country" value={value.country} onChange={(e) => onChange({ country: e.target.value })} />
      <TextField label="City" value={value.city} onChange={(e) => onChange({ city: e.target.value })} />
      <TextField label="Contact person" value={value.contact} onChange={(e) => onChange({ contact: e.target.value })} />
      <TextField label="Phone" value={value.phone} onChange={(e) => onChange({ phone: e.target.value })} />
      <FullRow>
        <TextField
          label="Email"
          type="email"
          value={value.email}
          onChange={(e) => onChange({ email: e.target.value })}
        />
      </FullRow>
    </>
  );
}
